import {executiveReportAPI} from "./api";
import {remontResponsibleAPI} from "@/components/modal/modals/change-remont-responsible/api";
import {financePaymentsAPI} from "@/views/FinancePayments/api";
import {fastSearchAPI} from "@/views/FastSearch/api";
import {downloadExcel} from "@/services";
import {getMainContractors} from "@/services/api/api";
import {timelineAPI} from "@/views/timeline/services/api";

const sanitizeExecutiveReportFilters = (filters = {}) => {
  const body = {...filters};
  if (body.remont_id === '' || body.remont_id === null || body.remont_id === undefined) {
    delete body.remont_id;
  } else {
    body.remont_id = Number(body.remont_id);
  }
  if (body.client_request_id === '' || body.client_request_id === null || body.client_request_id === undefined) {
    delete body.client_request_id;
  } else {
    body.client_request_id = Number(body.client_request_id);
  }
  if (body.contractor_main_id === '' || body.contractor_main_id === null || body.contractor_main_id === undefined) {
    delete body.contractor_main_id;
  }
  Object.keys(body).forEach(key => {
    if (Array.isArray(body[key]) && body[key].length === 0) {
      delete body[key];
    }
  });
  return body;
};

const GRADE_8_GROUP_ID = 10;

export const withGrade8Default = async (filters = {}) => {
  const next = {...filters};
  if (Number(next.mng_report_group_id) !== GRADE_8_GROUP_ID) return next;
  if (Array.isArray(next.grade_id_arr) && next.grade_id_arr.length) return next;
  const grades = await loadGradesForFilters();
  const grade = grades.find(item => item.grade_code === 'GRADE_8');
  if (!grade?.grade_id) return next;
  return {...next, grade_id_arr: [grade.grade_id]};
};

export const getExecutiveReportData = async body => {
  try {
    const payload = sanitizeExecutiveReportFilters(body);
    const res = await executiveReportAPI.getData(payload);
    return res?.mng_report;
  } catch (e) {
  }
};
export const getExecutiveReportAnalyze = async body => {
  try {
    const res = await executiveReportAPI.getReportAnalyze(sanitizeExecutiveReportFilters(body));
    if(!res) return
    const {data_1, data_2} = res
    return {doubleRemonts: data_2, lostRemonts: data_1}
  } catch (e) {
  }
};
export const executiveReportMeasureReady = async (body) => {
  try {
    const res = await executiveReportAPI.measureReady(body);
    return res?.mng_report;
  } catch (e) {
  }
};
export const downloadExecutiveReportExcel = async (body, title) => {
  try {
    const res = await executiveReportAPI.downloadExcel(body);
    downloadExcel(res, title);
  } catch (e) {
  }
};

export const getExecutiveReportTypesData = async () => {
  try {
    const res = await executiveReportAPI.getReportTypes();
    return res?.data;
  } catch (e) {
  }
};
export const getActionInfo = async (body) => {
  try {
    const res = await executiveReportAPI.getActionInfo(body);
    return res?.data;
  } catch (e) {
  }
};
export const addExecutiveReportComment = async (body) => {
  try {
    const res = await executiveReportAPI.addReportComment(body);
    return res?.data;
  } catch (e) {
  }
};
export const setExecutiveReportDeadline = async (body) => {
  try {
    const res = await executiveReportAPI.setDeadline(body);
    return res?.data;
  } catch (e) {
  }
};
export const setExecutiveReportNps = async (body) => {
  try {
    const res = await executiveReportAPI.setNps(body);
    return res?.data;
  } catch (e) {
  }
};
export const executiveReportAcceptWarranty = async (body) => {
  try {
    const res = await executiveReportAPI.warrantyAccept(body);
    return res?.data;
  } catch (e) {
  }
};
export const skipExecutiveReportNps = async (body) => {
  try {
    const res = await executiveReportAPI.skipNps(body);
    return res?.mng_report;
  } catch (e) {
  }
};
export const checkMaterialsAvail = async (body) => {
  try {
    const res = await executiveReportAPI.checkMaterialsAvail(body);
    if(!res) return
    const {mng_report, text} = res
    return {mng_report, text}
  } catch (e) {
  }
};
export const setExecutiveEmployee = async (body) => {
  try {
    const res = await executiveReportAPI.setEmployee(body);
    return res?.data;
  } catch (e) {
  }
};
export const setExecutiveEmployeeBulk = async (body) => {
  try {
    const res = await executiveReportAPI.setEmployeeBulk(body);
    return res?.data;
  } catch (e) {
  }
};
export const setExecutiveReportOkk = async (body) => {
  try {
    const res = await executiveReportAPI.setOkk(body);
    return res?.data;
  } catch (e) {
  }
};
export const deleteReportComment = async (mng_report_comment_id, body) => {
  try {
    const res = await executiveReportAPI.deleteReportComment(mng_report_comment_id, body);
    return res?.data;
  } catch (e) {
  }
};

const loadGradesForFilters = async () => {
  try {
    const res = await timelineAPI.getGrades();
    const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
    return list;
  } catch (e) {
    return [];
  }
};

export const getFiltersData = async () => {
  const settled = await Promise.allSettled([
    executiveReportAPI.getContractorsWithMain(),
    getMainContractors(),
    executiveReportAPI.getSalePoints(),
    fastSearchAPI.getResidents(),
    remontResponsibleAPI.getTechprojectEmployees(),
    remontResponsibleAPI.getProrabs(),
    remontResponsibleAPI.getProjectManagers(),
    financePaymentsAPI.getTechprojectDevelopers(),
    remontResponsibleAPI.getHeadDirections(),
    loadGradesForFilters(),
  ]);

  const value = (index) => settled[index].status === 'fulfilled' ? settled[index].value : undefined;

  const contractors = value(0);
  const mainContractors = value(1);
  const salePoints = value(2);
  const residentsRes = value(3);
  const techProjectEmployeesRes = value(4);
  const prorabsRes = value(5);
  const projectManagersRes = value(6);
  const techProjectDevsRes = value(7);
  const headDirectionsRes = value(8);
  const grades = value(9) || [];

  return {
    contractors: contractors || [],
    mainContractors: mainContractors || [],
    salePoints: salePoints || [],
    residents: residentsRes?.residents || [],
    techProjectEmployees: techProjectEmployeesRes?.data || [],
    prorabs: prorabsRes?.data || [],
    projectManagers: projectManagersRes?.data || [],
    techProjectDevs: techProjectDevsRes?.techproject_developers || [],
    headDirections: headDirectionsRes?.data || [],
    grades,
  };
};

export const fieldsToDelete = ["client_request_id", "comment_cnt", "color_id"];

export const executiveReportActionsCodes = {
  COMMENT: 'COMMENT',
  EMPLOYEE_SET: 'EMPLOYEE_SET',
  NPS_SUPPORT: 'NPS_SUPPORT',
  WCHECK_DEADLINE: 'WCHECK_DEADLINE',
  WCHECK_DEADLINE_VIEW: 'WCHECK_DEADLINE_VIEW',
  NPS_SUPPORT_SKIP: 'NPS_SUPPORT_SKIP',
  MATERIAL_ISSET_ACCEPT: 'MATERIAL_ISSET_ACCEPT',
  WARRANTY_ACCEPT: 'WARRANTY_ACCEPT',
  RESIDENT_OKK: 'RESIDENT_OKK',
  RESIDENT_FLAT_LIST: 'RESIDENT_FLAT_LIST',
  MEASURE_READY: 'MEASURE_READY',
}
export const actionInfoCodes = [executiveReportActionsCodes.COMMENT, executiveReportActionsCodes.EMPLOYEE_SET, executiveReportActionsCodes.NPS_SUPPORT, executiveReportActionsCodes.WCHECK_DEADLINE_VIEW
  , executiveReportActionsCodes.WARRANTY_ACCEPT, executiveReportActionsCodes.RESIDENT_OKK, executiveReportActionsCodes.RESIDENT_FLAT_LIST]